var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 1C6.4 1 1.5 5.9 1.5 12C1.5 18.1 6.4 23 12.5 23C18.6 23 23.5 18.1 23.5 12C23.5 5.9 18.6 1 12.5 1ZM12.5 21C7.5 21 3.5 17 3.5 12C3.5 7 7.5 3 12.5 3C17.5 3 21.5 7 21.5 12C21.5 17 17.5 21 12.5 21ZM16.5 13C17.1 13 17.5 12.6 17.5 12C17.5 11.4 17.1 11 16.5 11H13.5V8C13.5 7.4 13.1 7 12.5 7C11.9 7 11.5 7.4 11.5 8V11H8.5C7.9 11 7.5 11.4 7.5 12C7.5 12.6 7.9 13 8.5 13H11.5V16C11.5 16.6 11.9 17 12.5 17C13.1 17 13.5 16.6 13.5 16V13H16.5Z",
    fill: "#4F4F4F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8898_3006",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 23,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 1C6.4 1 1.5 5.9 1.5 12C1.5 18.1 6.4 23 12.5 23C18.6 23 23.5 18.1 23.5 12C23.5 5.9 18.6 1 12.5 1ZM12.5 21C7.5 21 3.5 17 3.5 12C3.5 7 7.5 3 12.5 3C17.5 3 21.5 7 21.5 12C21.5 17 17.5 21 12.5 21ZM16.5 13C17.1 13 17.5 12.6 17.5 12C17.5 11.4 17.1 11 16.5 11H13.5V8C13.5 7.4 13.1 7 12.5 7C11.9 7 11.5 7.4 11.5 8V11H8.5C7.9 11 7.5 11.4 7.5 12C7.5 12.6 7.9 13 8.5 13H11.5V16C11.5 16.6 11.9 17 12.5 17C13.1 17 13.5 16.6 13.5 16V13H16.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8898_3006)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0H24.5V24H0.5V0Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconWhite);
export default __webpack_public_path__ + "static/media/PlusIconWhite.37c65f486ef0ff3917542bb59c8f659d.svg";
export { ForwardRef as ReactComponent };